import React from "react";
import { MdSearch } from "react-icons/md";

export default function QuickSearchButton(props) {
    return (
        <div className="quick-search-button" onClick={props.onClick}>
            <span className="quick-search-button__icon">
                <MdSearch />
            </span>
            <span>{i18n.getString("quicksearch.buttontext")}</span>
        </div>
    );
}
